import { useState } from "react";
import PropTypes from "prop-types";
import FilterHeading from "./filter-heading";
import "../../../styles/reports-subscription/timesheet.css";

const FilterContainer = ({ children, onReset, grid = 4, gap = "20px", onExport, isExporting }) => {
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  return (
    <div className="timesheetContainer mt-3">
      <FilterHeading
        onReset={onReset}
        onToggleVisibility={toggleFilterVisibility}
        isFilterVisible={isFilterVisible}
        onExport={onExport}
        isExporting={isExporting}
      />

      {isFilterVisible && (
        <div className="timesheet_filter_body">
          <div className="timesheet_filter_body_block">{children}</div>
        </div>
      )}
    </div>
  );
};

export default FilterContainer;
